<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="摄影师配置" name="photographerConfiguration"> </el-tab-pane>
        <el-tab-pane label="拍摄核算标准" name="shootingAccountingStandards"> </el-tab-pane>
        <el-tab-pane label="提成系数配置" name="commissionCoefficient"> </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import photographerConfiguration from "./photographerConfiguration/photographerConfiguration";
import shootingAccountingStandards from "./shootingAccountingStandards/shootingAccountingStandards";
import commissionCoefficient from "./commissionCoefficient/commissionCoefficient";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "ShootingNodesConfiguration",
  mixins: [pagePathMixin],
  components: { photographerConfiguration, shootingAccountingStandards, commissionCoefficient },
  data() {
    return {
      activeName: "photographerConfiguration",
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>
